@if (popup === 'showFFUploadModal') {
  <div class="modal-body new-device-selection" id="compatible">
    <div class="row compare-devices" id="compare">
      @if (!noCompatibleFeatures()) {
        <div class="col-7 signifyBoldxl no-padding" id="PartiallyComp">Partially compatible features</div>
      }
      @if (noCompatibleFeatures()) {
        <div class="col-7 signifyBoldxl no-padding" id="noComp">No compatible features</div>
      }
      @if (hasSuccessfulFeatures) {
        <div class="col-5 signifyBookmd" id="featuresComp">(compatible features:
          @for (upload of uploadFeature.successfulFeatures; track upload; let lastItem = $last) {
            <span>{{upload}}
              @if (!lastItem) {
                <span>,&nbsp;</span>
              }
            </span>
            })
          </div>
          }<br><br><br>
          <div class="col-12 signifyBooklg no-padding add-margin" id="deviceName">{{device.deviceName}}</div>
          <br>
            <div class="col-5 no-padding" id="deviceCancel">
              <button class="btn another-btn prev-btn" (click)="[activeModal.dismiss('Cross click'), remove()]">Cancel</button>
            </div>
            <div class="col-6 no-padding" id="deviceConfirm">
              @if (hasSuccessfulFeatures) {
                <button class="btn new-confirm-btn confirm-btn signifyBoldlg"
                (click)="configureDevice()">Confirm</button>
              }
            </div>
          </div>
        </div>
      }